import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * GetQuoteButton Component
 * Features:
 * - Fixed-position floating button for mobile & desktop.
 * - Unique "Filling Water" Liquid UI effect on hover.
 * - Highly responsive CSS using clamp() for fluid scaling.
 * - Touch-optimized for mobile interactions.
 */

const GetQuoteButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/quotation');
  };

  return (
    <>
      <style>{`
        .get-quote-button {
          position: fixed;
          bottom: clamp(80px, 5vh, 80px); /* Scales between 40px and 80px based on viewport height */
          left: clamp(25px, 2vw, 25px); /* Scales between 10px and 25px based on viewport width */
          background-color: #0b5bef;
          border: 1px solid #022649;
          color: white;
          padding: clamp(8px, 1.5vw, 12px) clamp(20px, 3vw, 30px); /* Responsive padding */
          border-radius: clamp(30px, 5vw, 50px); /* Responsive border-radius */
          font-family: sans-serif;
          font-size: clamp(12px, 1.5vw, 14px); /* Responsive font size */
          font-weight: 600;
          text-decoration: none;
          text-transform: uppercase;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s ease;
          touch-action: manipulation; /* Improves touch interaction */
        }

        .get-quote-button span {
          position: relative;
          z-index: 5;
          pointer-events: none;
          letter-spacing: 1px;
        }

        /* --- Liquid Effect Styling --- */
        .get-quote-button .liquid {
          position: absolute;
          top: 100%; /* Hidden below by default */
          left: 0;
          width: 100%;
          height: 200px;
          background: #2893eb; 
          box-shadow: inset 0 0 50px rgba(0, 0, 0, 0.3);
          transition: 0.5s;
          z-index: 2;
        }

        /* Hover states: Fill with water and change border */
        .get-quote-button:hover {
          background-color: #022649;
          box-shadow: 0 10px 20px rgba(11, 91, 239, 0.3);
        }

        .get-quote-button:hover .liquid {
          top: -100px; /* Water rises */
        }

        /* Waves using pseudo-elements */
        .get-quote-button .liquid::after,
        .get-quote-button .liquid::before {
          content: '';
          width: 200%;
          height: 200%;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, -75%);
        }

        .get-quote-button .liquid::before {
          border-radius: 45%;
          background: rgba(2, 38, 73, 1); /* Dark blue to blend on hover */
          animation: liquid-animate 5s linear infinite;
        }

        .get-quote-button .liquid::after {
          border-radius: 40%;
          background: rgba(11, 91, 239, 0.5);
          animation: liquid-animate 10s linear infinite;
        }

        @keyframes liquid-animate {
          0% { transform: translate(-50%, -75%) rotate(0deg); }
          100% { transform: translate(-50%, -75%) rotate(360deg); }
        }

        /* Media Queries for Fine-Tuning */
        @media (max-width: 768px) {
          .get-quote-button {
            bottom: clamp(30px, 4vh, 60px); 
            left: clamp(8px, 1.5vw, 15px);
            padding: clamp(6px, 1vw, 8px) clamp(15px, 2vw, 20px);
            font-size: clamp(10px, 1.2vw, 12px);
          }
        }

        @media (max-width: 600px) {
          .get-quote-button {
            bottom: clamp(40px, 3vh, 40px);
            left: clamp(5px, 1vw, 10px);
            padding: clamp(5px, 0.8vw, 6px) clamp(10px, 1.5vw, 15px);
            font-size: clamp(8px, 1vw, 10px);
            border-radius: clamp(20px, 4vw, 30px);
          }
        }
      `}</style>

      <button onClick={handleClick} className="get-quote-button">
        <span>Quotation Requisition</span>
        <div className="liquid"></div>
      </button>
    </>
  );
};

export default GetQuoteButton;